import { checkGSTValid, formatDate } from "../../../../utilityFunctions";
import HelpIcon from "@mui/icons-material/Help";
import moment from "moment";
export const BkgPrintMessage = (props) => {
	const { msg } = props;
	return (
		<div className="agentDialogWrap">
			<div className="agentSvg">
				<HelpIcon
					sx={{ width: "36px", height: "36px", color: "#0086FF" }}
				/>
			</div>
			<div className="agentMessage">{msg}</div>
		</div>
	);
};
export const psgCurrentBkgColDef = [
	{
		headerName: "Name",
		field: "",
		headerSx: { textAlign: "left", width: "418px" },
	},
	{
		headerName: "Gender",
		field: "",
		headerSx: { textAlign: "left", width: "177px" },
	},
	{
		headerName: "Age",
		field: "",
		headerSx: { textAlign: "left", width: "177px" },
	},
	{
		headerName: "Concession",
		field: "",
		headerSx: { textAlign: "left", width: "177px" },
	},
	{
		headerName: "Nationality",
		field: "",
		headerSx: { textAlign: "left", width: "177px" },
	},
	{
		headerName: "Basic Fare",
		field: "",
		headerSx: { textAlign: "right", width: "177px" },
	},
];
export const passengerColumnDef = [
	{
		headerName: "Name",
		field: "",
		headerSx: { textAlign: "left", width: "418px" },
	},
	{
		headerName: "Gender",
		field: "",
		headerSx: { textAlign: "left", width: "177px" },
	},
	{
		headerName: "Age",
		field: "",
		headerSx: { textAlign: "left", width: "100px" },
	},
	{
		headerName: "Concession",
		field: "",
		headerSx: { textAlign: "left", width: "254px" },
	},
	{
		headerName: "Concession No",
		field: "",
		headerSx: { textAlign: "left", width: "177px" },
	},
	{
		headerName: "Nationality",
		field: "",
		headerSx: { textAlign: "left", width: "177px" },
	},
	{
		headerName: "Basic Fare",
		field: "",
		headerSx: { textAlign: "right", width: "177px" },
	},
];

export const passengerOthNationaColumnDef = [
	{
		headerName: "Name",
		field: "",
		headerSx: { textAlign: "left", width: "120px" },
	},
	{
		headerName: "Gender",
		field: "",
		headerSx: { textAlign: "left", width: "106px" },
	},
	{
		headerName: "Age",
		field: "",
		headerSx: { textAlign: "left", width: "80px" },
	},
	{
		headerName: "Nationality",
		field: "",
		headerSx: { textAlign: "left", width: "138px" },
	},
	{
		headerName: "Date Of Birth\nAs In Passport",
		field: "",
		headerSx: { textAlign: "left", width: "160px" },
	},
	{
		headerName: "Passport or Travel\nDocument Number",
		field: "",
		headerSx: { textAlign: "left", width: "150px" },
	},
	{
		headerName: "Address in India\n(Including Hotels)",
		field: "",
		headerSx: { textAlign: "left", width: "150px" },
	},
	{
		headerName: "Basic Fare",
		field: "",
		headerSx: { textAlign: "right", width: "98px" },
	},
];
export const passengerAllNationaColumnDef = [
	{
		headerName: "Name",
		field: "",
		headerSx: { textAlign: "left", width: "120px" },
	},
	{
		headerName: "Gender",
		field: "",
		headerSx: { textAlign: "left", width: "106px" },
	},
	{
		headerName: "Age",
		field: "",
		headerSx: { textAlign: "left", width: "80px" },
	},
	{
		headerName: "Concession",
		field: "",
		headerSx: { textAlign: "left", width: "150px" },
	},
	{
		headerName: "Concession No",
		field: "",
		headerSx: { textAlign: "left", width: "100px" },
	},
	{
		headerName: "Nationality",
		field: "",
		headerSx: { textAlign: "left", width: "138px" },
	},
	{
		headerName: "Date Of Birth\nAs In Passport",
		field: "",
		headerSx: { textAlign: "left", width: "150px" },
	},
	{
		headerName: "Passport or Travel\nDocument Number",
		field: "",
		headerSx: { textAlign: "left", width: "150px" },
	},
	{
		headerName: "Address in India\n(Including Hotels)",
		field: "",
		headerSx: { textAlign: "left", width: "150px" },
	},
	{
		headerName: "Basic Fare",
		field: "",
		headerSx: { textAlign: "right", width: "98px" },
	},
];
export const passengerSectionTotal = [
	{ name: "Reservation Fee (+)", field: "reservation" },
	{ name: "Concessions (-)", field: "concessions" },
	{ name: "ARF+UF+TF+EF+BF+INFRA (+)", field: "levies" },
	{ name: "GST (+)", field: "gst" },
	{ name: "Total Fare", field: "totalFare" },
	{ name: "RoundOff", field: "roundOff" },
	{ name: "Amount to be Collected", field: "balance" },
];

export const ticketColumnDef = [
	{
		headerName: "Trip\nCode",
		field: "",
		headerSx: { textAlign: "left", width: "98px" },
	},
	{
		headerName: "Depot\nName",
		field: "",
		headerSx: { textAlign: "left", width: "160px" },
	},
	{
		headerName: "Via\nPlace",
		field: "",
		headerSx: { textAlign: "left", width: "200px" },
	},
	{
		headerName: "Distance\n(Kms)",
		field: "",
		headerSx: { textAlign: "left", width: "77px" },
	},
	{
		headerName: "Departure\nTime",
		field: "",
		headerSx: { textAlign: "left", width: "58px" },
	},
	{
		headerName: "Arrival\nTime",
		field: "",
		headerSx: { textAlign: "left", width: "80px" },
	},
	{
		headerName: "Adult Fare\n(Incl.Levies)",
		field: "",
		headerSx: { textAlign: "right", width: "145px" },
	},
	{
		headerName: "Child\nFare",
		field: "",
		headerSx: { textAlign: "right", width: "58px" },
	},
	{
		headerName: "Type",
		field: "",
		headerSx: { textAlign: "left", width: "54px" },
	},
	{
		headerName: "Seats",
		field: "",
		headerSx: { textAlign: "left", width: "51px" },
	},
	{
		headerName: "Trip Sheet\nCut-Off Time",
		field: "",
		headerSx: { textAlign: "left", minWidth: "100px" },
	},
	{
		headerName: "Adult\nPax",
		field: "",
		headerSx: { textAlign: "left", width: "95px" },
	},
	{
		headerName: "Child\nPax",
		field: "",
		headerSx: { textAlign: "left", width: "95px" },
	},
	{
		headerName: "Action",
		field: "",
		headerSx: { textAlign: "left", width: "81px" },
	},
];

export const ticketColumnDefAdmin = [
	{
		headerName: "Trip\nCode",
		field: "",
		headerSx: { textAlign: "left", width: "98px" },
	},
	{
		headerName: "Depot\nName",
		field: "",
		headerSx: { textAlign: "left", width: "160px" },
	},
	{
		headerName: "Via\nPlace",
		field: "",
		headerSx: { textAlign: "left", width: "200px" },
	},
	{
		headerName: "Distance\n(Kms)",
		field: "",
		headerSx: { textAlign: "left", width: "77px" },
	},
	{
		headerName: "Departure\nTime",
		field: "",
		headerSx: { textAlign: "left", width: "65px" },
	},
	{
		headerName: "Arrival\nTime",
		field: "",
		headerSx: { textAlign: "left", width: "70px" },
	},
	{
		headerName: "Adult Fare/Adult Fare\n(Incl.Levies)",
		field: "",
		headerSx: { textAlign: "right", width: "200px" },
	},
	{
		headerName: "Child Fare/Child Fare(Incl.Levies)",
		field: "",
		headerSx: { textAlign: "right", width: "200px" },
	},
	{
		headerName: "Type",
		field: "",
		headerSx: { textAlign: "left", width: "54px" },
	},
	{
		headerName: "Seats",
		field: "",
		headerSx: { textAlign: "left", width: "51px" },
	},
	{
		headerName: "Trip Sheet\nCut-Off Time",
		field: "",
		headerSx: { textAlign: "left", minWidth: "100px" },
	},
	{
		headerName: "Adult\nPax",
		field: "",
		headerSx: { textAlign: "left", width: "95px" },
	},
	{
		headerName: "Child\nPax",
		field: "",
		headerSx: { textAlign: "left", width: "95px" },
	},
	{
		headerName: "Action",
		field: "",
		headerSx: { textAlign: "left", width: "81px" },
	},
];

export const paymentModaList = [
	{ id: 0, name: "Cash" },
	{ id: 1, name: "Credit/Debit" },
	{ id: 2, name: "Net Banking" },
	{ id: 3, name: "UPI" },
];
export const upiAppList = [
	{ id: 0, name: "PAYTM UPI" },
	{ id: 1, name: "GOOGLE PAY" },
	{ id: 2, name: "PHONE PAY" },
];
export const passengerListOpt = [
	{ id: 1, name: "1" },
	{ id: 2, name: "2" },
	{ id: 3, name: "3" },
	{ id: 4, name: "4" },
	{ id: 5, name: "5" },
	{ id: 6, name: "6" },
];

export const genderList = [
	{ id: "M", name: "Male" },
	{ id: "F", name: "Female" },
	{ id: "O", name: "Other" },
];
export const passengerSeatObj = {
	psgName: "",
	psgAge: "",
	psgGender: [],
	selConcession: [],
	ConcessionNo: "",
	psgNationality: [],
	passportDate: formatDate(window.getTime ? window.getTime() : new Date()),
	passWordNumber: "",
	addressIndia: "",
	baseFare: "",
	ChildFare: "",
	AdultFare: "",
};
export const bookingDetailsObj = {
	fullName: "",
	mobileNumber: "",
	emailId: "",
	gstIn: "",
	droppingPoint: [],
	boardingPoint: [],
	countryCode: [],
	selectSeatList: [],
	totalFare: "",
	roundOff: 0,
	disCount: 0,
	balance: 0,
	bkgConcession: [],
	BkgSeatData: []
};

export const returnObj = {
	countryCode: [],
	emailId: "",
	fullName: "",
	gstIn: "",
	mobileNumber: "",
	onwaryData: {},
	selNationality: [],
	selectSeatList: [],
	totalFare: 0,
	paymentModa: [],
	disCount: 0,
	roundOff: 0,
};

export const createCurrentTicketBody = (bookingDetails) => {
	return {
		WayBillNo: 0,
		TotalFare: bookingDetails?.totalFare,
		Fare1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.fare
				: 0,
		ConcessionTypeID1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.psgConcession?.[0]
					?.ConcessionTypeID
				: 0,
		ConcessionAmount1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.seatCon
				: 0,
		ConcessionRemarks1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.ConcessionNo
				: "",
		Fare2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.fare
				: 0,
		ConcessionTypeID2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.psgConcession?.[0]
					?.ConcessionTypeID
				: 0,
		ConcessionAmount2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.seatCon
				: 0,
		ConcessionRemarks2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.ConcessionNo
				: "",
		Fare3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.fare
				: 0,
		ConcessionTypeID3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.psgConcession?.[0]
					?.ConcessionTypeID
				: 0,
		ConcessionAmount3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.seatCon
				: 0,
		ConcessionRemarks3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.ConcessionNo
				: "",
		Fare4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.fare
				: 0,
		ConcessionTypeID4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.psgConcession?.[0]
					?.ConcessionTypeID
				: 0,
		ConcessionAmount4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.seatCon
				: 0,
		ConcessionRemarks4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.ConcessionNo
				: "",
		Fare5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.fare
				: 0,
		ConcessionTypeID5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.psgConcession?.[0]
					?.ConcessionTypeID
				: 0,
		ConcessionAmount5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.seatCon
				: 0,
		ConcessionRemarks5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.ConcessionNo
				: "",
		Fare6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.fare
				: 0,
		ConcessionTypeID6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.psgConcession?.[0]
					?.ConcessionTypeID
				: 0,
		ConcessionAmount6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.seatCon
				: 0,
		ConcessionRemarks6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.ConcessionNo
				: "",
		BridgeFee1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.bfAmt
				: 0,
		BridgeFee2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.bfAmt
				: 0,
		BridgeFee3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.bfAmt
				: 0,
		BridgeFee4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.bfAmt
				: 0,
		BridgeFee5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.bfAmt
				: 0,
		BridgeFee6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.bfAmt
				: 0,
		EntryFee1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.efAmt
				: 0,
		EntryFee2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.efAmt
				: 0,
		EntryFee3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.efAmt
				: 0,
		EntryFee4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.efAmt
				: 0,
		EntryFee5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.efAmt
				: 0,
		EntryFee6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.efAmt
				: 0,
		InfraFee1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.InfraFee
				: 0,
		InfraFee2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.InfraFee
				: 0,
		InfraFee3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.InfraFee
				: 0,
		InfraFee4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.InfraFee
				: 0,
		InfraFee5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.InfraFee
				: 0,
		InfraFee6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.InfraFee
				: 0,
		InsuranceFee1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.arfAmt
				: 0,
		InsuranceFee2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.arfAmt
				: 0,
		InsuranceFee3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.arfAmt
				: 0,
		InsuranceFee4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.arfAmt
				: 0,
		InsuranceFee5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.arfAmt
				: 0,
		InsuranceFee6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.arfAmt
				: 0,
		SRTFee1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.seatRes
				: 0,
		SRTFee2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.seatRes
				: 0,
		SRTFee3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.seatRes
				: 0,
		SRTFee4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.seatRes
				: 0,
		SRTFee5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.seatRes
				: 0,
		SRTFee6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.seatRes
				: 0,
		TollFee1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.tfAmt
				: 0,
		TollFee2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.tfAmt
				: 0,
		TollFee3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.tfAmt
				: 0,
		TollFee4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.tfAmt
				: 0,
		TollFee5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.tfAmt
				: 0,
		TollFee6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.tfAmt
				: 0,
		UserFee1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.ufAmt
				: 0,
		UserFee2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.ufAmt
				: 0,
		UserFee3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.ufAmt
				: 0,
		UserFee4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.ufAmt
				: 0,
		UserFee5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.ufAmt
				: 0,
		UserFee6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.ufAmt
				: 0,
		ConcessionID1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.psgConcession?.[0]
					?.ConcessionID
				: 0,
		ConcessionID2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.psgConcession?.[0]
					?.ConcessionID
				: 0,
		ConcessionID3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.psgConcession?.[0]
					?.ConcessionID
				: 0,
		ConcessionID4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.psgConcession?.[0]
					?.ConcessionID
				: 0,
		ConcessionID5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.psgConcession?.[0]
					?.ConcessionID
				: 0,
		ConcessionID6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.psgConcession?.[0]
					?.ConcessionID
				: 0,
		NationalityID1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.psgNationality?.[0]
					?.CountryName
				: "",
		NationalityID2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.psgNationality?.[0]
					?.CountryName
				: "",
		NationalityID3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.psgNationality?.[0]
					?.CountryName
				: "",
		NationalityID4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.psgNationality?.[0]
					?.CountryName
				: "",
		NationalityID5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.psgNationality?.[0]
					?.CountryName
				: "",
		NationalityID6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.psgNationality?.[0]
					?.CountryName
				: "",
		IDNumber1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.selectSeatList?.[0]?.passWordNumber
					: ""
				: "",
		IDNumber2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.selectSeatList?.[1]?.passWordNumber
					: ""
				: "",
		IDNumber3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.selectSeatList?.[2]?.passWordNumber
					: ""
				: "",
		IDNumber4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.selectSeatList?.[3]?.passWordNumber
					: ""
				: "",
		IDNumber5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.selectSeatList?.[4]?.passWordNumber
					: ""
				: "",
		IDNumber6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.selectSeatList?.[5]?.passWordNumber
					: ""
				: "",
		PassengerName: bookingDetails?.fullName,
		PassengerContactNo1: bookingDetails?.mobileNumber,
		PassengerContactNo2: "",
		PassengerEmailID: bookingDetails?.emailId,
		PassengerGSTNo: bookingDetails?.gstIn,
		PaxName1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.passengerName
				: "",
		PaxName2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.passengerName
				: "",
		PaxName3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.passengerName
				: "",
		PaxName4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.passengerName
				: "",
		PaxName5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.passengerName
				: "",
		PaxName6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.passengerName
				: "",
		PaxGender1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.passengeGender?.[0]?.id
				: "",
		PaxGender2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.passengeGender?.[0]?.id
				: "",
		PaxGender3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.passengeGender?.[0]?.id
				: "",
		PaxGender4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.passengeGender?.[0]?.id
				: "",
		PaxGender5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.passengeGender?.[0]?.id
				: "",
		PaxGender6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.passengeGender?.[0]?.id
				: "",
		PaxAge1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.passengerAge
				: 0,
		PaxAge2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.passengerAge
				: 0,
		PaxAge3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.passengerAge
				: 0,
		PaxAge4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.passengerAge
				: 0,
		PaxAge5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.passengerAge
				: 0,
		PaxAge6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.passengerAge
				: 0,
		PaxDOB1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.psgNationality?.[0]
					?.CountryID !== 1
					? moment(
						bookingDetails?.selectSeatList?.[0]?.passportDate
					).format("YYYY-MM-DD")
					: ""
				: "",
		PaxDOB2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.psgNationality?.[0]
					?.CountryID !== 1
					? moment(
						bookingDetails?.selectSeatList?.[1]?.passportDate
					).format("YYYY-MM-DD")
					: ""
				: "",
		PaxDOB3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.psgNationality?.[0]
					?.CountryID !== 1
					? moment(
						bookingDetails?.selectSeatList?.[2]?.passportDate
					).format("YYYY-MM-DD")
					: ""
				: "",
		PaxDOB4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.psgNationality?.[0]
					?.CountryID !== 1
					? moment(
						bookingDetails?.selectSeatList?.[3]?.passportDate
					).format("YYYY-MM-DD")
					: ""
				: "",
		PaxDOB5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.psgNationality?.[0]
					?.CountryID !== 1
					? moment(
						bookingDetails?.selectSeatList?.[4]?.passportDate
					).format("YYYY-MM-DD")
					: ""
				: "",
		PaxDOB6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.psgNationality?.[0]
					?.CountryID !== 1
					? moment(
						bookingDetails?.selectSeatList?.[5]?.passportDate
					).format("YYYY-MM-DD")
					: ""
				: "",
		PaxAdd1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.selectSeatList?.[0]?.addressIndia
					: ""
				: "",
		PaxAdd2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.selectSeatList?.[1]?.addressIndia
					: ""
				: "",
		PaxAdd3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.selectSeatList?.[2]?.addressIndia
					: ""
				: "",
		PaxAdd4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.selectSeatList?.[3]?.addressIndia
					: ""
				: "",
		PaxAdd5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.selectSeatList?.[4]?.addressIndia
					: ""
				: "",
		PaxAdd6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.selectSeatList?.[5]?.addressIndia
					: ""
				: "",
		PickupID: bookingDetails?.boardingPoint[0]?.PickupID,
		DropOffID: bookingDetails?.droppingPoint[0]?.DropoffID,
		CountryCode: bookingDetails?.countryCode?.[0]?.CountryCodeId || "",
		PkpCHarge1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.boardingPoint[0]?.PickupChargePer > 0
					? (bookingDetails?.selectSeatList?.[0]?.fare *
						bookingDetails?.boardingPoint[0]?.PickupChargePer) /
					100
					: bookingDetails?.boardingPoint[0]?.PickupChargeRs
				: 0,
		PkpCHarge2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.boardingPoint[0]?.PickupChargePer > 0
					? (bookingDetails?.selectSeatList?.[1]?.fare *
						bookingDetails?.boardingPoint[0]?.PickupChargePer) /
					100
					: bookingDetails?.boardingPoint[0]?.PickupChargeRs
				: 0,
		PkpCHarge3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.boardingPoint[0]?.PickupChargePer > 0
					? (bookingDetails?.selectSeatList?.[2]?.fare *
						bookingDetails?.boardingPoint[0]?.PickupChargePer) /
					100
					: bookingDetails?.boardingPoint[0]?.PickupChargeRs
				: 0,
		PkpCHarge4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.boardingPoint[0]?.PickupChargePer > 0
					? (bookingDetails?.selectSeatList?.[3]?.fare *
						bookingDetails?.boardingPoint[0]?.PickupChargePer) /
					100
					: bookingDetails?.boardingPoint[0]?.PickupChargeRs
				: 0,
		PkpCHarge5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.boardingPoint[0]?.PickupChargePer > 0
					? (bookingDetails?.selectSeatList?.[4]?.fare *
						bookingDetails?.boardingPoint[0]?.PickupChargePer) /
					100
					: bookingDetails?.boardingPoint[0]?.PickupChargeRs
				: 0,
		PkpCHarge6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.boardingPoint[0]?.PickupChargePer > 0
					? (bookingDetails?.selectSeatList?.[5]?.fare *
						bookingDetails?.boardingPoint[0]?.PickupChargePer) /
					100
					: bookingDetails?.boardingPoint[0]?.PickupChargeRs
				: 0,
		DrpCharge1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.droppingPoint[0]?.DropoffChargePer > 0
					? (bookingDetails?.selectSeatList?.[0]?.fare *
						bookingDetails?.droppingPoint[0]
							?.DropoffChargePer) /
					100
					: bookingDetails?.droppingPoint[0]?.DropoffChargeRs
				: 0,
		DrpCharge2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.droppingPoint[0]?.DropoffChargePer > 0
					? (bookingDetails?.selectSeatList?.[1]?.fare *
						bookingDetails?.droppingPoint[0]
							?.DropoffChargePer) /
					100
					: bookingDetails?.droppingPoint[0]?.DropoffChargeRs
				: 0,
		DrpCharge3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.droppingPoint[0]?.DropoffChargePer > 0
					? (bookingDetails?.selectSeatList?.[2]?.fare *
						bookingDetails?.droppingPoint[0]
							?.DropoffChargePer) /
					100
					: bookingDetails?.droppingPoint[0]?.DropoffChargeRs
				: 0,
		DrpCharge4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.droppingPoint[0]?.DropoffChargePer > 0
					? (bookingDetails?.selectSeatList?.[3]?.fare *
						bookingDetails?.droppingPoint[0]
							?.DropoffChargePer) /
					100
					: bookingDetails?.droppingPoint[0]?.DropoffChargeRs
				: 0,
		DrpCharge5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.droppingPoint[0]?.DropoffChargePer > 0
					? (bookingDetails?.selectSeatList?.[4]?.fare *
						bookingDetails?.droppingPoint[0]
							?.DropoffChargePer) /
					100
					: bookingDetails?.droppingPoint[0]?.DropoffChargeRs
				: 0,
		DrpCharge6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.droppingPoint[0]?.DropoffChargePer > 0
					? (bookingDetails?.selectSeatList?.[5]?.fare *
						bookingDetails?.droppingPoint[0]
							?.DropoffChargePer) /
					100
					: bookingDetails?.droppingPoint[0]?.DropoffChargeRs
				: 0,
		RoundOffAmount: bookingDetails?.roundOff,
		Discount: bookingDetails?.disCount,
		Discount1:
			bookingDetails?.selectSeatList.length > 0
				? bookingDetails?.selectSeatList?.[0]?.seatDis
				: 0,
		Discount2:
			bookingDetails?.selectSeatList.length > 1
				? bookingDetails?.selectSeatList?.[1]?.seatDis
				: 0,
		Discount3:
			bookingDetails?.selectSeatList.length > 2
				? bookingDetails?.selectSeatList?.[2]?.seatDis
				: 0,
		Discount4:
			bookingDetails?.selectSeatList.length > 3
				? bookingDetails?.selectSeatList?.[3]?.seatDis
				: 0,
		Discount5:
			bookingDetails?.selectSeatList.length > 4
				? bookingDetails?.selectSeatList?.[4]?.seatDis
				: 0,
		Discount6:
			bookingDetails?.selectSeatList.length > 5
				? bookingDetails?.selectSeatList?.[5]?.seatDis
				: 0,
	};
};


export const createCurrentBookedBody = (bookingDetails) => {
	return {
		WayBillNo: 0,
		TotalFare: bookingDetails?.totalFare,
		Fare1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.baseFare
				: 0,
		ConcessionTypeID1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.psgConcession?.[0]
					?.ConcessionTypeID
				: 0,
		ConcessionAmount1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.seatCon
				: 0,
		ConcessionRemarks1: "",
		Fare2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.baseFare
				: 0,
		ConcessionTypeID2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.psgConcession?.[0]
					?.ConcessionTypeID
				: 0,
		ConcessionAmount2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.seatCon
				: 0,
		ConcessionRemarks2: "",
		Fare3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.baseFare
				: 0,
		ConcessionTypeID3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.psgConcession?.[0]
					?.ConcessionTypeID
				: 0,
		ConcessionAmount3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.seatCon
				: 0,
		ConcessionRemarks3: "",
		Fare4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.baseFare
				: 0,
		ConcessionTypeID4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.psgConcession?.[0]
					?.ConcessionTypeID
				: 0,
		ConcessionAmount4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.seatCon
				: 0,
		ConcessionRemarks4: "",
		Fare5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.baseFare
				: 0,
		ConcessionTypeID5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.psgConcession?.[0]
					?.ConcessionTypeID
				: 0,
		ConcessionAmount5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.seatCon
				: 0,
		ConcessionRemarks5: "",
		Fare6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.baseFare
				: 0,
		ConcessionTypeID6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.psgConcession?.[0]
					?.ConcessionTypeID
				: 0,
		ConcessionAmount6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.seatCon
				: 0,
		ConcessionRemarks6: "",
		BridgeFee1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.bfAmt
				: 0,
		BridgeFee2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.bfAmt
				: 0,
		BridgeFee3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.bfAmt
				: 0,
		BridgeFee4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.bfAmt
				: 0,
		BridgeFee5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.bfAmt
				: 0,
		BridgeFee6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.bfAmt
				: 0,
		EntryFee1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.efAmt
				: 0,
		EntryFee2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.efAmt
				: 0,
		EntryFee3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.efAmt
				: 0,
		EntryFee4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.efAmt
				: 0,
		EntryFee5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.efAmt
				: 0,
		EntryFee6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.efAmt
				: 0,
		InfraFee1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.InfraFee
				: 0,
		InfraFee2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.InfraFee
				: 0,
		InfraFee3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.InfraFee
				: 0,
		InfraFee4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.InfraFee
				: 0,
		InfraFee5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.InfraFee
				: 0,
		InfraFee6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.InfraFee
				: 0,
		InsuranceFee1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.arfAmt
				: 0,
		InsuranceFee2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.arfAmt
				: 0,
		InsuranceFee3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.arfAmt
				: 0,
		InsuranceFee4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.arfAmt
				: 0,
		InsuranceFee5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.arfAmt
				: 0,
		InsuranceFee6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.arfAmt
				: 0,
		SRTFee1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.seatRes
				: 0,
		SRTFee2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.seatRes
				: 0,
		SRTFee3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.seatRes
				: 0,
		SRTFee4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.seatRes
				: 0,
		SRTFee5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.seatRes
				: 0,
		SRTFee6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.seatRes
				: 0,
		TollFee1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.tfAmt
				: 0,
		TollFee2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.tfAmt
				: 0,
		TollFee3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.tfAmt
				: 0,
		TollFee4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.tfAmt
				: 0,
		TollFee5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.tfAmt
				: 0,
		TollFee6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.tfAmt
				: 0,
		UserFee1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.ufAmt
				: 0,
		UserFee2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.ufAmt
				: 0,
		UserFee3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.ufAmt
				: 0,
		UserFee4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.ufAmt
				: 0,
		UserFee5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.ufAmt
				: 0,
		UserFee6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.ufAmt
				: 0,
		ConcessionID1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.psgConcession?.[0]
					?.ConcessionID
				: 0,
		ConcessionID2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.psgConcession?.[0]
					?.ConcessionID
				: 0,
		ConcessionID3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.psgConcession?.[0]
					?.ConcessionID
				: 0,
		ConcessionID4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.psgConcession?.[0]
					?.ConcessionID
				: 0,
		ConcessionID5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.psgConcession?.[0]
					?.ConcessionID
				: 0,
		ConcessionID6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.psgConcession?.[0]
					?.ConcessionID
				: 0,
		NationalityID1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.psgNationality?.[0]
					?.CountryName
				: "",
		NationalityID2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.psgNationality?.[0]
					?.CountryName
				: "",
		NationalityID3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.psgNationality?.[0]
					?.CountryName
				: "",
		NationalityID4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.psgNationality?.[0]
					?.CountryName
				: "",
		NationalityID5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.psgNationality?.[0]
					?.CountryName
				: "",
		NationalityID6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.psgNationality?.[0]
					?.CountryName
				: "",
		IDNumber1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.BkgSeatData?.[0]?.passWordNumber
					: ""
				: "",
		IDNumber2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.BkgSeatData?.[1]?.passWordNumber
					: ""
				: "",
		IDNumber3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.BkgSeatData?.[2]?.passWordNumber
					: ""
				: "",
		IDNumber4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.BkgSeatData?.[3]?.passWordNumber
					: ""
				: "",
		IDNumber5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.BkgSeatData?.[4]?.passWordNumber
					: ""
				: "",
		IDNumber6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.psgNationality?.[0]
					?.CountryID !== 1
					? bookingDetails?.BkgSeatData?.[5]?.passWordNumber
					: ""
				: "",
		PassengerName: "passenger1",
		PassengerContactNo1: 9999999999,
		PassengerContactNo2: "",
		PassengerEmailID: '',
		PassengerGSTNo: '',
		PaxName1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.passengerName
				: "",
		PaxName2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.passengerName
				: "",
		PaxName3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.passengerName
				: "",
		PaxName4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.passengerName
				: "",
		PaxName5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.passengerName
				: "",
		PaxName6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.passengerName
				: "",
		PaxGender1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.passengeGender?.[0]?.id
				: "",
		PaxGender2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.passengeGender?.[0]?.id
				: "",
		PaxGender3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.passengeGender?.[0]?.id
				: "",
		PaxGender4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.passengeGender?.[0]?.id
				: "",
		PaxGender5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.passengeGender?.[0]?.id
				: "",
		PaxGender6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.passengeGender?.[0]?.id
				: "",
		PaxAge1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.passengerAge
				: 0,
		PaxAge2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.passengerAge
				: 0,
		PaxAge3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.passengerAge
				: 0,
		PaxAge4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.passengerAge
				: 0,
		PaxAge5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.passengerAge
				: 0,
		PaxAge6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.passengerAge
				: 0,
		PaxDOB1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.psgNationality?.[0]
					?.CountryID !== 1
					? moment(
						bookingDetails?.BkgSeatData?.[0]?.passportDate
					).format("YYYY-MM-DD")
					: ""
				: "",
		PaxDOB2: "",
		PaxDOB3: "",
		PaxDOB4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.psgNationality?.[0]
					?.CountryID !== 1
					? moment(
						bookingDetails?.BkgSeatData?.[3]?.passportDate
					).format("YYYY-MM-DD")
					: ""
				: "",
		PaxDOB5: "",
		PaxDOB6: "",
		PaxAdd1: "",
		PaxAdd2: "",
		PaxAdd3: "",
		PaxAdd4: "",
		PaxAdd5: "",
		PaxAdd6: "",
		PickupID: bookingDetails?.boardingPoint[0]?.PickupID,
		DropOffID: bookingDetails?.droppingPoint[0]?.DropoffID,
		CountryCode: bookingDetails?.countryCode?.[0]?.CountryCodeId || "",
		PkpCHarge1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.boardingPoint[0]?.PickupChargePer > 0
					? (bookingDetails?.BkgSeatData?.[0]?.baseFare *
						bookingDetails?.boardingPoint[0]?.PickupChargePer) /
					100
					: bookingDetails?.boardingPoint[0]?.PickupChargeRs
				: 0,
		PkpCHarge2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.boardingPoint[0]?.PickupChargePer > 0
					? (bookingDetails?.BkgSeatData?.[1]?.baseFare *
						bookingDetails?.boardingPoint[0]?.PickupChargePer) /
					100
					: bookingDetails?.boardingPoint[0]?.PickupChargeRs
				: 0,
		PkpCHarge3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.boardingPoint[0]?.PickupChargePer > 0
					? (bookingDetails?.BkgSeatData?.[2]?.baseFare *
						bookingDetails?.boardingPoint[0]?.PickupChargePer) /
					100
					: bookingDetails?.boardingPoint[0]?.PickupChargeRs
				: 0,
		PkpCHarge4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.boardingPoint[0]?.PickupChargePer > 0
					? (bookingDetails?.BkgSeatData?.[3]?.baseFare *
						bookingDetails?.boardingPoint[0]?.PickupChargePer) /
					100
					: bookingDetails?.boardingPoint[0]?.PickupChargeRs
				: 0,
		PkpCHarge5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.boardingPoint[0]?.PickupChargePer > 0
					? (bookingDetails?.BkgSeatData?.[4]?.baseFare *
						bookingDetails?.boardingPoint[0]?.PickupChargePer) /
					100
					: bookingDetails?.boardingPoint[0]?.PickupChargeRs
				: 0,
		PkpCHarge6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.boardingPoint[0]?.PickupChargePer > 0
					? (bookingDetails?.BkgSeatData?.[5]?.baseFare *
						bookingDetails?.boardingPoint[0]?.PickupChargePer) /
					100
					: bookingDetails?.boardingPoint[0]?.PickupChargeRs
				: 0,
		DrpCharge1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.droppingPoint[0]?.DropoffChargePer > 0
					? (bookingDetails?.BkgSeatData?.[0]?.baseFare *
						bookingDetails?.droppingPoint[0]
							?.DropoffChargePer) /
					100
					: bookingDetails?.droppingPoint[0]?.DropoffChargeRs
				: 0,
		DrpCharge2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.droppingPoint[0]?.DropoffChargePer > 0
					? (bookingDetails?.BkgSeatData?.[1]?.baseFare *
						bookingDetails?.droppingPoint[0]
							?.DropoffChargePer) /
					100
					: bookingDetails?.droppingPoint[0]?.DropoffChargeRs
				: 0,
		DrpCharge3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.droppingPoint[0]?.DropoffChargePer > 0
					? (bookingDetails?.BkgSeatData?.[2]?.baseFare *
						bookingDetails?.droppingPoint[0]
							?.DropoffChargePer) /
					100
					: bookingDetails?.droppingPoint[0]?.DropoffChargeRs
				: 0,
		DrpCharge4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.droppingPoint[0]?.DropoffChargePer > 0
					? (bookingDetails?.BkgSeatData?.[3]?.baseFare *
						bookingDetails?.droppingPoint[0]
							?.DropoffChargePer) /
					100
					: bookingDetails?.droppingPoint[0]?.DropoffChargeRs
				: 0,
		DrpCharge5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.droppingPoint[0]?.DropoffChargePer > 0
					? (bookingDetails?.BkgSeatData?.[4]?.baseFare *
						bookingDetails?.droppingPoint[0]
							?.DropoffChargePer) /
					100
					: bookingDetails?.droppingPoint[0]?.DropoffChargeRs
				: 0,
		DrpCharge6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.droppingPoint[0]?.DropoffChargePer > 0
					? (bookingDetails?.BkgSeatData?.[5]?.baseFare *
						bookingDetails?.droppingPoint[0]
							?.DropoffChargePer) /
					100
					: bookingDetails?.droppingPoint[0]?.DropoffChargeRs
				: 0,
		RoundOffAmount: bookingDetails?.roundOff,
		Discount: bookingDetails?.disCount,
		Discount1:
			bookingDetails?.BkgSeatData.length > 0
				? bookingDetails?.BkgSeatData?.[0]?.seatDis
				: 0,
		Discount2:
			bookingDetails?.BkgSeatData.length > 1
				? bookingDetails?.BkgSeatData?.[1]?.seatDis
				: 0,
		Discount3:
			bookingDetails?.BkgSeatData.length > 2
				? bookingDetails?.BkgSeatData?.[2]?.seatDis
				: 0,
		Discount4:
			bookingDetails?.BkgSeatData.length > 3
				? bookingDetails?.BkgSeatData?.[3]?.seatDis
				: 0,
		Discount5:
			bookingDetails?.BkgSeatData.length > 4
				? bookingDetails?.BkgSeatData?.[4]?.seatDis
				: 0,
		Discount6:
			bookingDetails?.BkgSeatData.length > 5
				? bookingDetails?.BkgSeatData?.[5]?.seatDis
				: 0,
	};
};

export const currentBkgBody = (row) => {
	return {
		pnrNo: '',
		TripID: row?.TripID,
		ChartDate: moment(row?.ChartDate).format('YYYY-MM-DD'),
		JourneyDate: moment(row?.JourneyDate).format('YYYY-MM-DD'),
		FromCityID: row?.FromCityID,
		ToCityID: row?.ToCityID,
		WayBillNo: 0,
		SeatNo1: '',
		SeatTypeID1: 0,
		SeatNo2: '',
		SeatTypeID2: 0,
		SeatNo3: '',
		SeatTypeID3: 0,
		SeatNo4: '',
		SeatTypeID4: 0,
		SeatNo5: '',
		SeatTypeID5: 0,
		SeatNo6: '',
		SeatTypeID6: 0,
		UDID: '',
		AppBookingDateTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
		ForBranchId: 0,
		ForBranchUserId: 0,
		Remarks: '',
		CouponId: 0,
		PaymentModeID: 1,
		QRTransactionIds: '',
		QRTransactionAmts: '',
		SwipeIssuerID: 0,
		CardNo: '',
		TIDSequenceNo: 0,
		AppDevicePgTypeId: 0,

		IDCardID1: 0,
		IDCardID2: 0,
		IDCardID3: 0,
		IDCardID4: 0,
		IDCardID5: 0,
		IDCardID6: 0,
		PassengerContactNo2: '',
		DepartureTime: moment(row?.DepartureTimeActual).format('YYYY-MM-DD HH:mm:ss'),
		OnwardBookingID: 0,
	}
}
export const selectConcCurrentPerTicket = (
	seatArray = [],
	seatpostion,
	concessionOpt = [],
	selConcession = [],
	ConcessionTypeID
) => {
	let selectconcession = [...selConcession];
	let concession = concessionOpt?.filter(
		(obj) => obj?.ConcessionTypeID === ConcessionTypeID
	);
	if ([35, 4]?.includes(Number(ConcessionTypeID))) {
		let newSeatArray = seatArray.map((value, index) => {
			let gender =
				concession?.[0]?.Gender === value?.psgGender?.[0]?.id ||
				concession?.[0]?.Gender === "" ||
				(concession?.[0]?.Gender === "O" &&
					value?.psgGender?.[0]?.id === "M");
			if (
				concession.length > 0 &&
				concession?.[0]?.MaxPersonPerTicket >
				selectconcession.filter(
					(item, index1) =>
						index1 !== index &&
						item == concession?.[0]?.ConcessionTypeID
				).length &&
				value?.psgGender.length > 0 &&
				value?.psgAge.trim() !== "" &&
				(value?.psgAge !== ""
					? value?.psgAge > 11
						? true
						: index === seatpostion
							? concession?.[0]?.IsChild === 1
							: value?.selConcession?.[0]?.IsChild === 1
					: false) &&
				((
					index === seatpostion
						? concession?.[0]?.ConcessionTypeID === 35
						: ConcessionTypeID === 35
							? value.selConcession.length === 0 ||
							value?.selConcession?.[0]?.ConcessionTypeID === 35
							: value?.selConcession?.[0]?.ConcessionTypeID === 35
				)
					? value?.psgAge > 59
					: true) &&
				gender
			) {
				if (
					value.selConcession.length === 0 ||
					![35, 4]?.includes(
						Number(value?.selConcession?.[0]?.ConcessionTypeID)
					)
				) {
					if (35 === ConcessionTypeID && value?.psgAge < 60) {
						selectconcession[index] = "";
						return {
							...value,
							selConcession: [],
							ConcessionNo: "",
						};
					} else {
						selectconcession[index] =
							concession?.[0]?.ConcessionTypeID;
						return {
							...value,
							selConcession: concession,
							ConcessionNo: "",
						};
					}
				} else if (
					[35, 4]?.includes(
						Number(value?.selConcession?.[0]?.ConcessionTypeID)
					) &&
					value.selConcession.length > 0 &&
					value?.selConcession?.[0]?.ConcessionTypeID !==
					ConcessionTypeID
				) {
					if (35 === ConcessionTypeID && value?.psgAge > 59) {
						selectconcession[index] =
							concession?.[0]?.ConcessionTypeID;
						return {
							...value,
							selConcession: concession,
							ConcessionNo: "",
						};
					} else if (
						4 === ConcessionTypeID &&
						seatpostion === index &&
						value?.psgAge > 59
					) {
						selectconcession[index] =
							concession?.[0]?.ConcessionTypeID;
						return {
							...value,
							selConcession: concession,
							ConcessionNo: "",
						};
					} else {
						return value;
					}
				} else {
					return value;
				}
			} else {
				selectconcession[index] = "";
				return { ...value, selConcession: [], ConcessionNo: "" };
			}
		});
		return { newSeatArray, selectconcession };
	} else {
		let newSeatArray = seatArray.map((value, index) => {
			let gender =
				concession?.[0]?.Gender === value?.psgGender?.[0]?.id ||
				concession?.[0]?.Gender === "" ||
				(concession?.[0]?.Gender === "O" &&
					value?.psgGender?.[0]?.id === "M");
			if (
				concession.length > 0 &&
				concession?.[0]?.MaxPersonPerTicket >
				selectconcession.filter(
					(item, index1) =>
						index1 !== index &&
						item == concession?.[0]?.ConcessionTypeID
				).length &&
				value?.psgGender.length > 0 &&
				value?.psgAge.trim() !== "" &&
				(value?.psgAge !== ""
					? value?.psgAge > 11
						? true
						: concession?.[0]?.IsChild === 1
					: false) &&
				(concession?.[0]?.ConcessionTypeID === 35
					? value?.psgAge > 59
					: true) &&
				gender
			) {
				selectconcession[index] = concession?.[0]?.ConcessionTypeID;
				return {
					...value,
					selConcession: concession,
					ConcessionNo: "",
				};
			} else {
				selectconcession[index] = "";
				return { ...value, selConcession: [], ConcessionNo: "" };
			}
		});
		return { newSeatArray, selectconcession };
	}
};

export const checkCurrBookingValue = (arr) => {
	let checkingValue = false;
	let errorMsg = [];
	arr.forEach((val) => {
		if (val?.selConcession.length > 0) {
			if (
				val?.selConcession?.[0]?.IsCardEntry === 1 &&
				val?.ConcessionNo?.trim() === ""
			) {
				errorMsg?.push(val?.selConcession?.[0]?.ConcessionTypeName);
				checkingValue = true;
			}
		}
	});
	return {
		checkingValue,
		errorMsg: `Please Enter Concession No for ${Array.from(
			new Set(errorMsg)
		)?.join(",")}`,
	};
};

export const debounce = (func, delay) => {
	let timeoutId;
	return function (...args) {
		const context = this;
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => func.apply(context, args), delay);
	};
};

export const CalculatorPayment = (
	baseFare,
	IsChild,
	discountCalculator = [],
	totalSeat,
	selConcession = [],
	leviesOpt = [],
	gstIn = '',
	gstCalculator = [],
	row = {}
) => {
	let seatRes = 0;
	let seatCon = 0;
	let seatGst = 0;
	let arfAmt = 0;
	let ufAmt = 0;
	let tfAmt = 0;
	let efAmt = 0;
	let bfAmt = 0;
	let InfraFee = 0;
	let gstPre = 0;
	let IsPercentageGST = false;
	let seatDis = 0;
	let totalLevies = 0;

	if (
		discountCalculator?.length > 0 &&
		totalSeat >= discountCalculator?.[0]?.MinSeat &&
		selConcession[0]?.ConcessionPer < discountCalculator?.[0]?.OnwardPtc
	) {

		if (!((Object.keys(row)?.length > 0 && row?.ServiceTypeID === 15) && Number(totalSeat) > 2)) {
			seatDis += Math.floor(
				(baseFare * discountCalculator?.[0]?.OnwardPtc) / 100
			);
		}
	} else {
		let preConcession = (baseFare * selConcession[0]?.ConcessionPer) / 100;
		if (selConcession[0]?.RoundOff === 1) {
			let amount = Math.floor(preConcession);
			seatCon = amount;
		}
		if (selConcession[0]?.RoundOff === 2) {
			let amount = Math.ceil(preConcession);
			seatCon = amount;
		}
		if (selConcession[0]?.RoundOff === 3) {
			let amount = Math.round(preConcession);
			seatCon = amount;
		}
	}
	leviesOpt.map((obj) => {
		let amount = 0;
		let concessionLevies =
			selConcession?.[0]?.CorporationLavyIDs?.split(",");
		if (
			obj?.MinBaseFare <= baseFare &&
			obj?.MaxBaseFare >= baseFare &&
			concessionLevies.includes(obj.CorporationLevyID?.toString())
		) {
			if (obj?.IsPercentage === 1) {
				if (obj?.LevyID === 3) {
					IsPercentageGST = true;
					if (IsChild) {
						gstPre += obj?.ChildAmount;
					} else {
						gstPre += obj?.AdultAmount;
					}
				} else {
					if (IsChild) {
						amount = (baseFare * obj?.ChildAmount) / 100;
					} else {
						amount = (baseFare * obj?.AdultAmount) / 100;
					}
				}
			} else {
				if (obj?.LevyID === 3) {
					IsPercentageGST = false;
					if (IsChild) {
						gstPre += obj?.ChildAmount;
					} else {
						gstPre += obj?.AdultAmount;
					}
				} else {
					if (IsChild) {
						amount = obj?.ChildAmount;
					} else {
						amount = obj?.AdultAmount;
					}
				}
			}
			if (obj.LevyID === 6) {
				seatRes += amount;
			} else if ([5, 8, 2, 4, 1, 7].includes(obj?.LevyID)) {
				totalLevies += amount;
				if (obj?.LevyID === 5) {
					arfAmt += amount;
				} else if (obj?.LevyID === 8) {
					ufAmt += amount;
				} else if (obj?.LevyID === 2) {
					efAmt += amount;
				} else if (obj?.LevyID === 1) {
					bfAmt += amount;
				} else if (obj?.LevyID === 7) {
					tfAmt += amount;
				} else if (obj?.LevyID === 4) {
					InfraFee += amount;
				}
			} else if (obj?.LevyID === 3) {
				seatGst += amount;
			}
		}
	});
	let gstAmount = gstPre === 0 ? 0 : IsPercentageGST ? ((Number(baseFare) + seatRes - seatCon - seatDis + arfAmt + ufAmt + tfAmt + efAmt + bfAmt + InfraFee) * gstPre) / 100 : (Number(baseFare) + seatRes - seatCon - seatDis + arfAmt + ufAmt + tfAmt + efAmt + bfAmt + InfraFee + gstPre)
	if (gstAmount !== 0) {
		if (gstCalculator?.length === 0) {
			seatGst += Math.ceil(gstAmount)
		} else if (gstCalculator?.length !== 0 && gstIn.trim() === '') {
			seatGst += Math.ceil(gstAmount / 2) * 2
		} else if (gstCalculator?.length !== 0 && checkGSTValid(gstIn) && gstCalculator?.[0]?.GSTStateCode === parseInt(gstIn.trim()?.slice(0, 2))) {
			seatGst += Math.ceil(gstAmount / 2) * 2
		} else {
			seatGst += Math.ceil(gstAmount)
		}
	}
	return { seatRes, seatCon, seatGst, arfAmt, ufAmt, tfAmt, efAmt, bfAmt, InfraFee, gstPre, IsPercentageGST, seatDis, totalLevies }
};


export const checkAdultChild = (arr) => {
	let adultNo = 0
	let childNo = 0
	arr?.forEach((val) => {
		if (Number(val?.passengerAge) > 11) {
			adultNo += 1
		} else if (Number(val?.passengerAge) < 12) {
			childNo += 1
		}
	})
	return { adultNo, childNo }
}